import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import ProductCard from '../ProductCard/ProductCard';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ProductSection.css';

const ProductSection = ({ title, products, viewAllLink, brands = [] }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <section className="product-section">
      <div className="container">
        <div className="section-header">
          <div className="section-title-wrapper">
            <h2 className="section-title">{title}</h2>
            {brands.length > 0 && (
              <div className="section-brands">
                {brands.map((brand, index) => (
                  <Link 
                    key={index} 
                    to={`/shop?brand=${brand.toLowerCase()}`}
                    className="section-brand-link"
                  >
                    {brand}
                  </Link>
                ))}
              </div>
            )}
          </div>
          {viewAllLink && (
            <Link to={viewAllLink} className="view-all-link">
              View All →
            </Link>
          )}
        </div>

        <div className="product-slider">
          <Slider {...settings}>
            {products.map(product => (
              <div key={product.id} className="product-slide">
                <ProductCard product={product} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
